import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "fixed inset-x-0 z-100 bg-blue-400 text-white flex items-center justify-between p-4 bottom-0" }
const _hoisted_2 = { class: "flex items-center justify-center space-x-8 w-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavButton = _resolveComponent("NavButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_NavButton, {
        icon: "home",
        sectionId: "home"
      }),
      _createVNode(_component_NavButton, {
        icon: "heart",
        sectionId: "love"
      }),
      _createVNode(_component_NavButton, {
        icon: "calendar",
        sectionId: "weddingDate"
      }),
      _createVNode(_component_NavButton, {
        icon: "images",
        sectionId: "gallery"
      }),
      _createVNode(_component_NavButton, {
        icon: "comment",
        sectionId: "comments"
      })
    ])
  ]))
}